import { render, staticRenderFns } from "./NewSupplierModal.vue?vue&type=template&id=57c4d39f&"
import script from "./NewSupplierModal.vue?vue&type=script&lang=js&"
export * from "./NewSupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./NewSupplierModal.vue?vue&type=style&index=0&id=57c4d39f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports